import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, unref as _unref, withKeys as _withKeys, isRef as _isRef, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "card" }
const _hoisted_2 = { class: "flex w-full" }
const _hoisted_3 = { class: "flex flex-col" }
const _hoisted_4 = { class: "flex w-full" }
const _hoisted_5 = { class: "flex justify-start" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", { class: "mb-4" }, "Filtrer par date de validité.", -1)
const _hoisted_7 = { class: "mx-auto mb-4" }
const _hoisted_8 = { class: "flex grid-cols-1 md:grid-cols-3 gap-1" }
const _hoisted_9 = { class: "flex items-end" }
const _hoisted_10 = { class: "card-toolbar w-full row" }
const _hoisted_11 = { class: "p-input-icon-left" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_13 = { class: "p-input-icon-left ml-4 mr-3" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("i", { class: "pi pi-search" }, null, -1)
const _hoisted_15 = { class: "p-input-icon-left" }
const _hoisted_16 = { class: "flex flex-col items-end justify-end ml-auto" }
const _hoisted_17 = { class: "flex w-full justify-end ml-auto" }
const _hoisted_18 = { class: "w-full" }
const _hoisted_19 = { class: "card-body pt-0" }

import Column from "primevue/column";
import Button from "primevue/button";
import InputText from "primevue/inputtext";
import DataTable from "primevue/datatable";
import {ref, onMounted, watch} from "vue";
import { fetchCodesAvailable } from "@/_services/code/code";
import { Code } from "@/models/product/code/Code";
import swal from "@/_helpers/swal";
import { getLocalStorageRowsPerPage, setLocalStorageRowsPerPage } from "@/_services/localStorage.service";
import ApiService from "@/_services/api.service";
import moment from "moment";

const localStorageKey = "selectedCodes";
const defaultRowsPerPage = 10;

export default /*#__PURE__*/_defineComponent({
  __name: 'StockCodeAvailableList',
  setup(__props) {

const isLoading = ref<boolean>(true);
const codes = Array<Code>();
const tableData = ref<Array<Code>>(codes);
const selectedCodes = ref(Array<Code>());
const availabilityStartDate = ref<string>('');
const availabilityEndDate = ref<string>('');

const rows = ref<number>(10);
const rowsPerPageOptions = [defaultRowsPerPage, 25, 100];
const codeNameModel = ref<string>("");
const totalRecords = ref<number>(0);
const page = ref<number>(1);
const currentPage = ref<number>(0);
let supplierModel = ref('');
let productNameModel = ref('');
async function populateDatatable() {
    let paramsFilter = {
        name: codeNameModel.value,
        supplier:supplierModel.value,
        productName: productNameModel.value,
        availabilityStartDate: availabilityStartDate.value,
        availabilityEndDate: availabilityEndDate.value,
    };
  const [loadingDt,totalRecordsDt, tableDataDt] = await fetchCodesAvailable(rows.value, page.value, paramsFilter);
  isLoading.value = loadingDt;
  tableData.value = tableDataDt;
  totalRecords.value = totalRecordsDt;
}

watch([availabilityStartDate, availabilityEndDate],
    ([newAvailabilityStartDate, newAvailabilityEndDate], [prevAvailabilityStartDate, prevAvailabilityEndDate]) => {
    if ((newAvailabilityStartDate === '' || newAvailabilityStartDate === undefined)
        && (newAvailabilityEndDate === '' || newAvailabilityEndDate === undefined)
        && productNameModel.value === ""
        && codeNameModel.value === ""
    ) {
        clearDtSelectedCode();
    }
});

const onPaginate = async (e) => {
    rows.value = e.rows;
    currentPage.value = e.page;
    page.value = e.page + 1;
    populateDatatable();
};

const onFilterDt = () => {
    if (productNameModel.value === ""
        && codeNameModel.value === ""
        && isAvailabilityStartDateEmpty()
        && isAvailabilityEndDateEmpty()
    ) {
        clearDtSelectedCode();
    }
    
    rows.value = 10;
    page.value = 1;
    populateDatatable();
};

onMounted(async () => {
  await populateDatatable();
  setLocalStorageRowsPerPage(rows.value, localStorageKey);
});

function disableGroupAction(selectedCodes){
  selectedCodes.length <= 0
    ? swal.warning("Veuillez selectionner au moins un code")
    :
    swal
      .confirm(
        `Êtes-vous sûr de vouloir désactiver  les (${selectedCodes.length}) Code(s) ?`
      )
      .then((result) => {
        if (result.isConfirmed) {
          disableGroupCodes(selectedCodes);
        }else {
          window.location.reload();
        }
      });
}

async function disableGroupCodes(selectedCodes) {
  const uuidArray = getSelectedCodeUuids(selectedCodes);

  const dataToSendToApi = {
    codes: uuidArray,
  };

  await ApiService.patchWithoutSlug("disable_product_codes", dataToSendToApi)
    .then(() => {
      swal.info(`Vous venez de désactiver les codes.`).then(() => {
        window.location.reload();
      });
    })
    .catch(() => {
      swal.error().then(() => {
        window.location.reload();
      });
    });
}

function getSelectedCodeUuids(selectedCodes) {
  return selectedCodes.map((code) => code.uuid);
}
async function searchSuppliers({search}) {
    if (!search || search.length < 3) return [];
    const fetchSuppliers = await ApiService.get(`suppliers?name=${search || ''}&isActive=true`);
    return fetchSuppliers.data.data.map((val: any) => {
        return {
            label: val.name,
            value: val.uuid
        }
    });
}

const checkDatesIntervalRules = (node: any) => {
    const selectedDate = node.value;
    if (typeof availabilityStartDate.value !== 'undefined' && typeof availabilityEndDate.value !== 'undefined') {
        return moment(availabilityStartDate.value).isSameOrBefore(availabilityEndDate.value);
    }

    return true;
}

const filterAvailableDocumentsByExpirationDate = async () => {
    isLoading.value = true;
    try {
        await populateDatatable();
    } catch (error) {
        swal.error("Erreur lors de la recherche par date d'expiration");
    } finally {
        isLoading.value = false;
    }
}

const clearDtSelectedCode = () => {
    selectedCodes.value = [];
};

const isAvailabilityStartDateEmpty = (): boolean => {
    return availabilityStartDate.value === "" || availabilityStartDate.value === undefined;
}

const isAvailabilityEndDateEmpty = (): boolean => {
    return availabilityEndDate.value === "" || availabilityEndDate.value === undefined;
}


return (_ctx: any,_cache: any) => {
  const _component_FormKit = _resolveComponent("FormKit")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(DataTable), {
      value: tableData.value,
      rows: rows.value,
      paginator: true,
      loading: isLoading.value,
      rowsPerPageOptions: rowsPerPageOptions,
      selection: selectedCodes.value,
      "onUpdate:selection": _cache[6] || (_cache[6] = ($event: any) => ((selectedCodes).value = $event)),
      lazy: "",
      onPage: onPaginate,
      currentPage: currentPage.value,
      totalRecords: totalRecords.value
    }, {
      header: _withCtx(() => [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createVNode(_component_FormKit, {
                  type: "form",
                  actions: false
                }, {
                  default: _withCtx(({ state: { valid } }) => [
                    _hoisted_6,
                    _createElementVNode("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createVNode(_component_FormKit, {
                          type: "datepicker",
                          name: "availabilityStartDate",
                          label: "Date de début",
                          validation: "checkDatesIntervalRules",
                          "validation-rules": { checkDatesIntervalRules: checkDatesIntervalRules },
                          "validation-messages": {
                        checkDatesIntervalRules: 'La date de début doit être inférieur ou égale à la date de fin.',
                      },
                          "validation-visibility": "live",
                          format: "DD/MM/YYYY",
                          "value-format": "YYYY-MM-DD",
                          modelValue: availabilityStartDate.value,
                          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((availabilityStartDate).value = $event)),
                          clearable: ""
                        }, null, 8, ["validation-rules", "validation-messages", "modelValue"]),
                        _createVNode(_component_FormKit, {
                          type: "datepicker",
                          name: "availabilityEndDate",
                          label: "Date de fin",
                          validation: "checkDatesIntervalRules",
                          "validation-rules": { checkDatesIntervalRules: checkDatesIntervalRules },
                          "validation-messages": {
                            checkDatesIntervalRules: 'La date de fin doit être supérieure ou égale à la date de début.',
                          },
                          "validation-visibility": "live",
                          format: "DD/MM/YYYY",
                          "value-format": "YYYY-MM-DD",
                          modelValue: availabilityEndDate.value,
                          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((availabilityEndDate).value = $event)),
                          clearable: ""
                        }, null, 8, ["validation-rules", "validation-messages", "modelValue"]),
                        _createElementVNode("div", _hoisted_9, [
                          _createVNode(_component_FormKit, {
                            type: "button",
                            label: "Filtrer",
                            class: _normalizeClass({ 'btn-secondary': true, 'btn-block': true }),
                            onClick: filterAvailableDocumentsByExpirationDate,
                            disabled: !valid || isLoading.value
                          }, null, 8, ["disabled"])
                        ])
                      ])
                    ])
                  ]),
                  _: 1
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, [
                _hoisted_12,
                _createVNode(_unref(InputText), {
                  modelValue: codeNameModel.value,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((codeNameModel).value = $event)),
                  placeholder: "Rechercher un code",
                  onKeyup: _withKeys(onFilterDt, ["enter"])
                }, null, 8, ["modelValue", "onKeyup"])
              ]),
              _createElementVNode("span", _hoisted_13, [
                _hoisted_14,
                _createVNode(_unref(InputText), {
                  modelValue: _unref(productNameModel),
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_isRef(productNameModel) ? (productNameModel).value = $event : productNameModel = $event)),
                  placeholder: "Rechercher par produit",
                  onKeyup: _withKeys(onFilterDt, ["enter"])
                }, null, 8, ["modelValue", "onKeyup"])
              ]),
              _createElementVNode("span", _hoisted_15, [
                _createVNode(_component_FormKit, {
                  type: "autocomplete",
                  name: "supplier",
                  placeholder: "Sélectionner un fournisseur",
                  options: searchSuppliers,
                  modelValue: _unref(supplierModel),
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_isRef(supplierModel) ? (supplierModel).value = $event : supplierModel = $event))
                }, null, 8, ["modelValue"])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_16, [
            _createElementVNode("div", _hoisted_17, [
              _createVNode(_unref(Button), {
                size: "small",
                class: "btn btn-primary p-2 ps-2 pe-2 justify-end ml-auto",
                style: {"margin-bottom":"0.5em"},
                title: "Désactiver la liste des Codes",
                onClick: _cache[5] || (_cache[5] = ($event: any) => (disableGroupAction(selectedCodes.value)))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" Désactiver la liste des Codes ")
                ]),
                _: 1
              })
            ]),
            _createElementVNode("div", _hoisted_18, [
              _createElementVNode("p", null, "Nombre de ligne sélectionnée(s) : " + _toDisplayString(selectedCodes.value.length) + " Code(s)", 1)
            ])
          ])
        ])
      ]),
      empty: _withCtx(() => [
        _createTextVNode("Aucun résultat trouvé.")
      ]),
      default: _withCtx(() => [
        _createElementVNode("div", _hoisted_19, [
          _createVNode(_unref(Column), { selectionMode: "multiple" }),
          _createVNode(_unref(Column), {
            field: "code",
            header: "Code"
          }),
          _createVNode(_unref(Column), {
            field: "productName",
            header: "Nom du produit"
          }),
          _createVNode(_unref(Column), {
            field: "productType",
            header: "Type de produit"
          }),
          _createVNode(_unref(Column), {
            field: "supplierName",
            header: "Fournisseur"
          }),
          _createVNode(_unref(Column), {
            field: "expirationDate",
            header: "Expiration"
          })
        ])
      ]),
      _: 1
    }, 8, ["value", "rows", "loading", "selection", "currentPage", "totalRecords"])
  ]))
}
}

})